export const DRAWER_OVERLAY_QUERIES: string[] = [
  '(max-width: 800px)',
  '(max-height: 500px) and (pointer: coarse)',
];
